import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useApiRequest from '../../lib/hooks/useRequest';
import useVerified from '../../lib/hooks/useVerified';
import BgStickyGradient from '../../ui/flow-components/bg-sticky-gradient';
import GradientText from '../../ui/flow-components/gradient-text';
import TextFade from '../../ui/flow-components/text-fade';
const MailVerification = () => {
  const { apiRequest } = useApiRequest();
  let [searchParams] = useSearchParams();

  const { checkVerification } = useVerified();

  const mail = searchParams.get('mail');

  const resendMail = async () => {
    await apiRequest('user-profile/resend-email-verification', 'POST', {
      toast: {
        toastText: 'Email wurde erneut gesendet'
      }
    });
  };

  useEffect(() => {
    checkVerification();
  }, [checkVerification]);

  return (
    <div className="min-h-screen relative w-screen bg-[#000f0f] overflow-hidden">
      <BgStickyGradient />
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-1/2 z-0 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{ backgroundColor: 'rgba(95, 213, 222, 0.1)', filter: 'blur(120px)' }}
      />
      <div className="flex flex-col w-full min-h-screen relative z-10 justify-center items-center p-6">
        <div className="flex flex-col items-center gap-16 ">
          <div className="flex flex-col items-center gap-2">
            <p className="text-base text-center mb-2 font-['LibreCaslonText'] italic font">
              <GradientText>7i7® flow</GradientText>
            </p>
            <p className="text-white text-2xl lg:text-4xl font-medium text-center">
              <GradientText shadow="none">E-Mail</GradientText> <TextFade direction="right">bestätigen</TextFade>
            </p>
          </div>
          <div className="max-w-[360px] flex flex-col gap-4 items-center">
            <p className="text-base text-[#B2B7B7] text-center">Eine Email wurde an {mail ?? 'Ihre Mail'} gesendet</p>
            <p className="text-base text-[#B2B7B7] text-center">
              Um Zugriff auf alle Funktionen zu erhalten, bestätigen Sie bitte Ihre Email-Adresse. Überprüfen Sie Ihren Posteingang und klicken Sie
              auf den Bestätigungslink. Schauen Sie auch in Ihrem Spam-Ordner nach.
            </p>
            <div
              className="w-full rounded-full p-[1px] max-w-[280px]"
              style={{
                background: 'linear-gradient(180deg, #266D74 0%, #B2EDFF 100%)'
              }}>
              <button
                type="button"
                onClick={resendMail}
                className="group relative flex h-10 w-full items-center justify-between rounded-full pl-4 pr-1 pb-1 pt-1 text-white transition-all hover:brightness-110"
                style={{
                  background: 'linear-gradient(90deg, #23444B 0%, #88D4A9 88%)',
                  boxShadow: '0 2.74px 6.91px 0 #78CCC0, inset 0 2.74px 4.52px 0 #172D30'
                }}>
                <span className="pl-2 text-sm leading-none">
                  <span className="mr-1.5 font-['LibreCaslonText'] italic font">Jetzt</span>
                  <span className="">Email erneut senden</span>
                </span>
                <div
                  className="flex h-full aspect-square items-center justify-center rounded-full p-1.5"
                  style={{
                    background: 'linear-gradient(135deg, #4D4D4A 0%, #747473 22%, #575757 41%, #040E0F 70%, #4D4D4D 84%, #999999 100%)'
                  }}>
                  <img src="/button-pointer.svg" alt="arrow-right" className="h-full w-full" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { MailVerification };
